import React, { useEffect } from "react";
import "./OfferPopup.css";

const OfferPopup = ({ onClose }) => {

  useEffect(() => {
    // 10 seconds ke baad automatically close
    const timer = setTimeout(() => {
      onClose();
    }, 9000000);

    // component remove hone par timer clear
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="offer-overlay">

      <div className="offer-popup">

        {/* Close Button */}
        <button
          className="offer-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        {/* Promotional Image */}
        <img
          src="/Image/offer.png"
          alt="Navratri Special Offer"
          className="offer-image"
        />

      </div>

    </div>
  );
};

export default OfferPopup;